// This file is auto-generated by the Stimulus controller setup.
// It loads all controllers from the controllers directory.

import { application } from "./application"

// Manually import and register all the controllers
import AlertController from "./alert_controller"
import BillingBusinessToggleController from "./billing_business_toggle_controller"
import TestAlertController from "./test-alert_controller"
import DropdownController from "./dropdown_controller"
import ModalController from "./modal_controller"
import MusicAnalyticsController from "./music_analytics_controller"
import TabsController from "./tabs_controller"
import FormController from "./form_controller"
import FormTimerController from "./form_timer_controller"
import SidebarController from "./sidebar_controller"
import SidebarDropdownController from "./sidebar_dropdown_controller"
import ContactFormController from "./contact_form_controller"
import FileUploadController from "./file_upload_controller"
import ImagePromptController from "./image_prompt_controller"
import ImageUploadController from "./image_upload_controller"
import ChartController from "./chart_controller"
import RichTextEditorController from "./rich_text_editor_controller"
import ResponsiveFormController from "./responsive_form_controller"
import TextareaHeightController from "./textarea_height_controller"

// Pure Tailwind controllers (no Bootstrap dependencies)
import SidebarPureController from "./sidebar_pure_controller"
import SidebarDropdownPureController from "./sidebar_dropdown_pure_controller"
import DropdownPureController from "./dropdown_pure_controller"
import ModalPureController from "./modal_pure_controller"
import EventModalController from "./event_modal_controller"
import SelectController from "./select_controller"
import SmoothieBuilderController from "./smoothie_builder_controller"
import SmoothieShareController from "./smoothie_share_controller"
import CoffeeRatioCalculatorController from "./coffee_ratio_calculator_controller"
import CaffeineClearanceCalculatorController from "./caffeine_clearance_calculator_controller"
import EmbedSnippetController from "./embed_snippet_controller"
import GalleryLightboxController from "./gallery_lightbox_controller"
import BreakfastQuizController from "./breakfast_quiz_controller"
import ExerciseController from "./exercise_controller"
import RecipeScalerController from "./recipe_scaler_controller"
import ShoppingListController from "./shopping_list_controller"
import RecipeSaveController from "./recipe_save_controller"
import FridgeController from "./fridge_controller"
import BulkSelectController from "./bulk_select_controller"
import SortableListController from "./sortable_list_controller"
import AudioPreviewController from "./audio_preview_controller"
import CollapseController from "./collapse_controller"
import LoadingFormController from "./loading_form_controller"
import GenerationPollController from "./generation_poll_controller"
import GenerationContextController from "./generation_context_controller"
import ExternalDestinationFormController from "./external_destination_form_controller"
import DomainNameFormController from "./domain_name_form_controller"
import OauthCredentialsController from "./oauth_credentials_controller"
import LayoutPickerController from "./layout_picker_controller"

// Priority+ navigation controller (calculator nav)
import PriorityPlusController from "./priority_plus_controller"

// SalaryLab Calculator controllers
import SalaryLabCalculatorController from "./salary_lab_calculator_controller"
import SalaryLabChartController from "./salary_lab_chart_controller"
import SalaryLabContractorController from "./salary_lab_contractor_controller"
import SalaryLabReverseController from "./salary_lab_reverse_controller"
import SalaryLabComparisonController from "./salary_lab_comparison_controller"
import SalaryLabShareController from "./salary_lab_share_controller"
import SalaryLabBenchmarkController from "./salary_lab_benchmark_controller"
import SalaryLabRoleSelectorController from "./salary_lab_role_selector_controller"
import SalaryLabEmployerCostController from "./salary_lab_employer_cost_controller"
import SalaryLabCostToEmployController from "./salary_lab_cost_to_employ_controller"
import SalaryLabKiwisaverController from "./salary_lab_kiwisaver_controller"
import SalaryLabStudentLoanController from "./salary_lab_student_loan_controller"
import SalaryLabScenariosController from "./salary_lab_scenarios_controller"
import SalaryLabMinimumWageController from "./salary_lab_minimum_wage_controller"
import SalaryLabCostOfLivingController from "./salary_lab_cost_of_living_controller"
import SalaryLabBudgetPlannerController from "./salary_lab_budget_planner_controller"
import SalaryLabSocialShareController from "./salary_lab_social_share_controller"
import SalaryLabPdfController from "./salary_lab_pdf_controller"
import SalaryLabSaveController from "./salary_lab_save_controller"
import SalaryLabAdvisorController from "./salary_lab_advisor_controller"
import SalaryLabAdvisorMemoryController from "./salary_lab_advisor_memory_controller"
import SalaryLabCvUploadController from "./salary_lab_cv_upload_controller"
import SalaryLabNegotiationController from "./salary_lab_negotiation_controller"
import SalaryLabCvAnalyserController from "./salary_lab_cv_analyser_controller"
import SalaryLabLinkedinAnalyserController from "./salary_lab_linkedin_analyser_controller"

// CV Builder controllers
import CvBuilderController from "./cv_builder_controller"
import CvBuilderFormController from "./cv_builder_form_controller"
import CvBuilderPreviewController from "./cv_builder_preview_controller"
import CvBuilderSuggestionsController from "./cv_builder_suggestions_controller"
import CvBuilderSectionOrderController from "./cv_builder_section_order_controller"

// Analytics tracking controllers
import UpgradePromptTrackerController from "./upgrade_prompt_tracker_controller"
import LeaderboardTrackerController from "./leaderboard_tracker_controller"

// Salary Database controllers
import JobRoleAutocompleteController from "./job_role_autocomplete_controller"
import SalaryFormController from "./salary_form_controller"
import SatisfactionRatingController from "./satisfaction_rating_controller"
import SearchAutocompleteController from "./search_autocomplete_controller"

// Auth/Signup controllers
import SignupTermsController from "./signup_terms_controller"

// Content Block controllers
import GalleryController from "./gallery_controller"
import AccordionController from "./accordion_controller"
import CounterController from "./counter_controller"
import CodeWalkthroughController from "./code_walkthrough_controller"

// Content Block Editor controllers (Panel)
import DynamicListController from "./dynamic_list_controller"
import ContentBlocksSortableController from "./content_blocks_sortable_controller"
import BlockPreviewController from "./block_preview_controller"
import ContentStructureToggleController from "./content_structure_toggle_controller"

// Advertising controller (Panel)
import AdvertisingSettingsController from "./advertising_settings_controller"

// Featured Articles controller (Panel)
import FeaturedArticlesController from "./featured_articles_controller"

// Featured Recipes controller (Panel — breakfast.co.nz)
import FeaturedRecipesController from "./featured_recipes_controller"

// AutoBlog controllers (Panel)
import SectionRevisionController from "./section_revision_controller"
import InlineEditController from "./inline_edit_controller"

// MoneySmart controllers
import MobileMenuController from "./mobile_menu_controller"
import CompoundInterestCalculatorController from "./compound_interest_calculator_controller"
import MortgageRepaymentCalculatorController from "./mortgage_repayment_calculator_controller"
import MortgageToolsPdfController from "./mortgage_tools_pdf_controller"
import SavingsGoalCalculatorController from "./savings_goal_calculator_controller"
import BudgetPlannerCalculatorController from "./budget_planner_calculator_controller"
import DebtPayoffCalculatorController from "./debt_payoff_calculator_controller"
import NetWorthCalculatorController from "./net_worth_calculator_controller"
import KiwiSaverComparisonController from "./kiwi_saver_comparison_controller"
import ComparisonTableController from "./comparison_table_controller"
import MsFeeCalculatorController from "./ms_fee_calculator_controller"
import OnboardingQuizController from "./onboarding_quiz_controller"
import SaveScenarioController from "./save_scenario_controller"
import MoneysmartSocialShareController from "./moneysmart_social_share_controller"
import MoneysmartPdfController from "./moneysmart_pdf_controller"
import MoneysmartRateHistoryController from "./moneysmart_rate_history_controller"

// Survey controllers
import SurveyWidgetController from "./survey_widget_controller"
import SurveyQuestionFormController from "./survey_question_form_controller"

// Traffic source and video embed controllers (salaries2 YouTube/TikTok integration)
import TrafficSourceController from "./traffic_source_controller"
import VideoEmbedController from "./video_embed_controller"

// Lesson video facade (language-learning layouts: cafecito, modoingles)
import LessonVideoController from "./lesson_video_controller"

// Infinite scroll controller (salaries2 article index)
import InfiniteScrollController from "./infinite_scroll_controller"

// Video Generation controllers (Panel)
import TemplateSelectController from "./template_select_controller"
import AudioEditorController from "./audio_editor_controller"
import AudioLibraryPickerController from "./audio_library_picker_controller"
import VoiceoverTimelineController from "./voiceover_timeline_controller"
import AdminJobRoleAutocompleteController from "./admin_job_role_autocomplete_controller"
import MultiRoleAutocompleteController from "./multi_role_autocomplete_controller"
import VideoGenerationFormController from "./video_generation_form_controller"
import VideoTypePickerController from "./video_type_picker_controller"
import SelectOrCustomController from "./select_or_custom_controller"

// Register all controllers with the application
application.register("alert", AlertController)
application.register("music-analytics", MusicAnalyticsController)
application.register("billing-business-toggle", BillingBusinessToggleController)
application.register("test-alert", TestAlertController)
application.register("dropdown", DropdownController)
application.register("modal", ModalController)
application.register("tabs", TabsController)
application.register("form", FormController)
application.register("form-timer", FormTimerController)
application.register("sidebar", SidebarController)
application.register("sidebar-dropdown", SidebarDropdownController)
application.register("contact-form", ContactFormController)
application.register("file-upload", FileUploadController)
application.register("image-prompt", ImagePromptController)
application.register("image-upload", ImageUploadController)
application.register("chart", ChartController)
application.register("rich-text-editor", RichTextEditorController)
application.register("responsive-form", ResponsiveFormController)
application.register("textarea-height", TextareaHeightController)

// Register Pure Tailwind controllers
application.register("sidebar-pure", SidebarPureController)
application.register("sidebar-dropdown-pure", SidebarDropdownPureController)
application.register("dropdown-pure", DropdownPureController)
application.register("modal-pure", ModalPureController)
application.register("event-modal", EventModalController)
application.register("select", SelectController)
application.register("smoothie-builder", SmoothieBuilderController)
application.register("smoothie-share", SmoothieShareController)
application.register("coffee-ratio-calculator", CoffeeRatioCalculatorController)
application.register("caffeine-clearance-calculator", CaffeineClearanceCalculatorController)
application.register("embed-snippet", EmbedSnippetController)
application.register("gallery-lightbox", GalleryLightboxController)
application.register("breakfast-quiz", BreakfastQuizController)
application.register("exercise", ExerciseController)
application.register("recipe-scaler", RecipeScalerController)
application.register("shopping-list", ShoppingListController)
application.register("recipe-save", RecipeSaveController)
application.register("fridge", FridgeController)
application.register("bulk-select", BulkSelectController)
application.register("sortable-list", SortableListController)
application.register("audio-preview", AudioPreviewController)
application.register("collapse", CollapseController)
application.register("loading-form", LoadingFormController)
application.register("generation-poll", GenerationPollController)
application.register("generation-context", GenerationContextController)
application.register("external-destination-form", ExternalDestinationFormController)
application.register("domain-name-form", DomainNameFormController)
application.register("oauth-credentials", OauthCredentialsController)
application.register("layout-picker", LayoutPickerController)

// Register Priority+ navigation controller
application.register("priority-plus", PriorityPlusController)

// Register SalaryLab Calculator controllers
application.register("salary-lab-calculator", SalaryLabCalculatorController)
application.register("salary-lab-chart", SalaryLabChartController)
application.register("salary-lab-contractor", SalaryLabContractorController)
application.register("salary-lab-reverse", SalaryLabReverseController)
application.register("salary-lab-comparison", SalaryLabComparisonController)
application.register("salary-lab-share", SalaryLabShareController)
application.register("salary-lab-benchmark", SalaryLabBenchmarkController)
application.register("salary-lab-role-selector", SalaryLabRoleSelectorController)
application.register("salary-lab-employer-cost", SalaryLabEmployerCostController)
application.register("salary-lab-cost-to-employ", SalaryLabCostToEmployController)
application.register("salary-lab-kiwisaver", SalaryLabKiwisaverController)
application.register("salary-lab-student-loan", SalaryLabStudentLoanController)
application.register("salary-lab-scenarios", SalaryLabScenariosController)
application.register("salary-lab-minimum-wage", SalaryLabMinimumWageController)
application.register("salary-lab-cost-of-living", SalaryLabCostOfLivingController)
application.register("salary-lab-budget-planner", SalaryLabBudgetPlannerController)
application.register("salary-lab-social-share", SalaryLabSocialShareController)
application.register("salary-lab-pdf", SalaryLabPdfController)
application.register("salary-lab-save", SalaryLabSaveController)
application.register("salary-lab-advisor", SalaryLabAdvisorController)
application.register("salary-lab-advisor-memory", SalaryLabAdvisorMemoryController)
application.register("salary-lab-cv-upload", SalaryLabCvUploadController)
application.register("salary-lab-negotiation", SalaryLabNegotiationController)
application.register("salary-lab-cv-analyser", SalaryLabCvAnalyserController)
application.register("salary-lab-linkedin-analyser", SalaryLabLinkedinAnalyserController)

// Register CV Builder controllers
application.register("cv-builder", CvBuilderController)
application.register("cv-builder-form", CvBuilderFormController)
application.register("cv-builder-preview", CvBuilderPreviewController)
application.register("cv-builder-suggestions", CvBuilderSuggestionsController)
application.register("cv-builder-section-order", CvBuilderSectionOrderController)

// Register Pricing toggle controller
import PricingToggleController from "./pricing_toggle_controller"
application.register("pricing-toggle", PricingToggleController)

// Register Scroll hint controller (fade overlay for horizontally scrollable tables)
import ScrollHintController from "./scroll_hint_controller"
application.register("scroll-hint", ScrollHintController)

// Register Scroll-to-top controller (auto-scrolls to top after Turbo Stream updates)
import ScrollToTopController from "./scroll_to_top_controller"
application.register("scroll-to-top", ScrollToTopController)

// Register Analytics tracking controllers
application.register("upgrade-prompt-tracker", UpgradePromptTrackerController)
application.register("leaderboard-tracker", LeaderboardTrackerController)

// Register Salary Database controllers
application.register("job-role-autocomplete", JobRoleAutocompleteController)
application.register("salary-form", SalaryFormController)
application.register("satisfaction-rating", SatisfactionRatingController)
application.register("search-autocomplete", SearchAutocompleteController)

// Register Auth/Signup controllers
application.register("signup-terms", SignupTermsController)

// Register Content Block controllers
application.register("gallery", GalleryController)
application.register("accordion", AccordionController)
application.register("counter", CounterController)
application.register("code-walkthrough", CodeWalkthroughController)

// Register Content Block Editor controllers (Panel)
application.register("dynamic-list", DynamicListController)
application.register("content-blocks-sortable", ContentBlocksSortableController)
application.register("block-preview", BlockPreviewController)
application.register("content-structure-toggle", ContentStructureToggleController)

// Register Advertising controller (Panel)
application.register("advertising-settings", AdvertisingSettingsController)

// Register Featured Articles controller (Panel)
application.register("featured-articles", FeaturedArticlesController)

// Register Featured Recipes controller (Panel — breakfast.co.nz)
application.register("featured-recipes", FeaturedRecipesController)

// Register AutoBlog controllers (Panel)
application.register("section-revision", SectionRevisionController)
application.register("inline-edit", InlineEditController)

// Register Video Generation controllers (Panel)
application.register("template-select", TemplateSelectController)
application.register("audio-editor", AudioEditorController)
application.register("audio-library-picker", AudioLibraryPickerController)
application.register("voiceover-timeline", VoiceoverTimelineController)
application.register("admin-job-role-autocomplete", AdminJobRoleAutocompleteController)
application.register("multi-role-autocomplete", MultiRoleAutocompleteController)
application.register("video-generation-form", VideoGenerationFormController)
application.register("video-type-picker", VideoTypePickerController)
application.register("select-or-custom", SelectOrCustomController)

// Register MoneySmart controllers
application.register("mobile-menu", MobileMenuController)
application.register("compound-interest-calculator", CompoundInterestCalculatorController)
application.register("mortgage-repayment-calculator", MortgageRepaymentCalculatorController)
application.register("mortgage-tools-pdf", MortgageToolsPdfController)
application.register("savings-goal-calculator", SavingsGoalCalculatorController)
application.register("budget-planner-calculator", BudgetPlannerCalculatorController)
application.register("debt-payoff-calculator", DebtPayoffCalculatorController)
application.register("net-worth-calculator", NetWorthCalculatorController)
application.register("kiwi-saver-comparison", KiwiSaverComparisonController)
application.register("comparison-table", ComparisonTableController)
application.register("ms-fee-calculator", MsFeeCalculatorController)
application.register("onboarding-quiz", OnboardingQuizController)
application.register("save-scenario", SaveScenarioController)
application.register("moneysmart-social-share", MoneysmartSocialShareController)
application.register("moneysmart-pdf", MoneysmartPdfController)
application.register("moneysmart-rate-history", MoneysmartRateHistoryController)

// Register Survey controllers
application.register("survey-widget", SurveyWidgetController)
application.register("survey-question-form", SurveyQuestionFormController)

// Register Clipboard controller
import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

// Register Traffic source and video embed controllers
application.register("traffic-source", TrafficSourceController)
application.register("video-embed", VideoEmbedController)

// Register the lesson video facade
application.register("lesson-video", LessonVideoController)

// Register Infinite scroll controller
application.register("infinite-scroll", InfiniteScrollController)

// Tweet Dashboard controllers (Panel)
import TweetCalendarController from "./tweet_calendar_controller"
application.register("tweet-calendar", TweetCalendarController)

// Vignette series filter (ayearonthefarm.com and similar series-mode sites)
import SeriesFilterController from "./series_filter_controller"
application.register("series-filter", SeriesFilterController)

// Cookie / privacy banner — render persistently until visitor clicks acknowledge
import CookieBannerController from "./cookie_banner_controller"
application.register("cookie-banner", CookieBannerController)

// Smart paste (panel block editor): Word/HTML clipboard -> content blocks
import SmartPasteController from "./smart_paste_controller"
application.register("smart-paste", SmartPasteController)

// Playlist/curator template (e.g. bossaplaylists.com): lazy embed facade + theme filter
import PlaylistEmbedController from "./playlist_embed_controller"
application.register("playlist-embed", PlaylistEmbedController)
import PlaylistFilterController from "./playlist_filter_controller"
application.register("playlist-filter", PlaylistFilterController)
import PlaylistVibeController from "./playlist_vibe_controller"
application.register("playlist-vibe", PlaylistVibeController)

// Salaries Business-tier: live preview of white-label report branding
import BrandingPreviewController from "./branding_preview_controller"
application.register("branding-preview", BrandingPreviewController)

// Engineering blog widgets (embedded in article content blocks)
import CoercionPlaygroundController from "./coercion_playground_controller"
application.register("coercion-playground", CoercionPlaygroundController)
import CssPoolingToggleController from "./css_pooling_toggle_controller"
application.register("css-pooling-toggle", CssPoolingToggleController)
import SilentConfigPlaygroundController from "./silent_config_playground_controller"
application.register("silent-config-playground", SilentConfigPlaygroundController)
import ReplayableTerminalController from "./replayable_terminal_controller"
application.register("replayable-terminal", ReplayableTerminalController)

// Readout archetype (devgab): faceplate/instrument chrome + article telemetry.
// Names match the frozen readout markup (DESIGN-SPEC §f). Inert without their
// data-controller attributes, so bundle-bytes are the only cost to other tenants.
import ThemeLatchController from "./theme_latch_controller"
application.register("theme-latch", ThemeLatchController)
import StripController from "./strip_controller"
application.register("strip", StripController)
import MetersController from "./meters_controller"
application.register("meters", MetersController)
import ArticleTraceController from "./article_trace_controller"
application.register("article-trace", ArticleTraceController)
import TransportController from "./transport_controller"
application.register("transport", TransportController)
import StepperController from "./stepper_controller"
application.register("stepper", StepperController)
import TerminalController from "./terminal_controller"
application.register("terminal", TerminalController)
import PowerLatchController from "./power_latch_controller"
application.register("power-latch", PowerLatchController)
import PlaygroundPlanetController from "./playground_planet_controller"
application.register("playground-planet", PlaygroundPlanetController)
import SigLevelController from "./sig_level_controller"
application.register("sig-level", SigLevelController)

// Signal catalogue interactions, mounted only by the Signal templates.
import SignalShellController from "./signal_shell_controller"
application.register("signal-shell", SignalShellController)
import SignalSearchController from "./signal_search_controller"
application.register("signal-search", SignalSearchController)
import SignalTabsController from "./signal_tabs_controller"
application.register("signal-tabs", SignalTabsController)
import SignalPlayerController from "./signal_player_controller"
application.register("signal-player", SignalPlayerController)
import SignalProgressController from "./signal_progress_controller"
application.register("signal-progress", SignalProgressController)
import SignalArticleController from "./signal_article_controller"
application.register("signal-article", SignalArticleController)
import SignalLibraryController from "./signal_library_controller"
application.register("signal-library", SignalLibraryController)

// Inline animated site logos (any template that renders one).
import AnimatedLogoController from "./animated_logo_controller"
application.register("animated-logo", AnimatedLogoController)

import VideoMetadataController from "./video_metadata_controller"
application.register("video-metadata", VideoMetadataController)
